import './App.css';
import React, { useState } from 'react';
import StlInsert from './components/StlInsert';
import NavigationBar from './components/NavigationBar';
import Cart from './components/Cart';


function App() {
const [cart, setCart] = useState([]);

//https://craftcloud3d.com/
//https://www.npmjs.com/package/react-gcode-viewer

  return (
    <div className="App">

      <NavigationBar/>

        <div className='mainDiv'>
        <Cart cart={cart} setCart={setCart} className="CartComponent"/>
        
        <StlInsert cart={cart} setCart={setCart} className="StlInsertComponent"/>
        </div>

    </div>
  );
}

export default App;
